export const LOADING_PLAN_INDIVIDUAL = "LOADING_PLAN_INDIVIDUAL";
export const SAVE_LOADING_PLAN_INDIVIDUAL = "SAVE_LOADING_PLAN_INDIVIDUAL";
export const GET_PLAN_INDIVIDUAL = "GET_PLAN_INDIVIDUAL";
export const FORM_FAIL = "FORM_FAIL";
export const PLAN_INDIVIDUAL_FAIL = "PLAN_INDIVIDUAL_FAIL";
